module.exports = __webpack_public_path__ + "static/media/cSPorter.dfb12b7a.jpeg";